import { Pipe, PipeTransform } from 'ng-metadata/core';

import * as angular from 'angular';
import * as states from '../lang/states.json';
import * as countries from '../lang/countries.json';

@Pipe({
  name: 'country',
})
export class CountryPipe implements PipeTransform {

  transform(isoCode: string|any, type: string|any): string|any {
    if (typeof isoCode !== 'string') {
      return isoCode;
    }

    const search = type === 'state' ? states : countries;

    const found = (<any>search).find((place) => {
      return place.iso === isoCode;
    });

    if (!found) return isoCode;
    return found.name;
  }

}



// WEBPACK FOOTER //
// ./resources/assets/js/pipes/country.pipe.ts